import React, { useEffect, useRef } from 'react';

export interface WebPImageElement extends HTMLImageElement {
  srcSet: string;
}

export type ImageSourceProps = {
  image: string;
  imageAlt: string;
  imageWebp?: WebPImageElement;
  imageMobile?: string;
  imageMobileWebp?: WebPImageElement;
  sizes?: string;
  style?: React.CSSProperties;
  [x: string]: unknown;
};

export const ImageSource: React.FC<ImageSourceProps> = ({
  image,
  imageWebp,
  imageMobile,
  imageMobileWebp,
  imageAlt,
  sizes,
  ...otherProps
}) => {
  const imgRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    if (imgRef.current) {
      imgRef.current.src = image;
    }
  }, [imgRef, image]);

  return imageWebp && /\.(jpe?g|png)$/.test(image) ? (
    <picture className='display-flex margin-s'>
      {imageMobileWebp && (
        <source type='image/webp' srcSet={imageMobileWebp.srcSet} sizes={sizes} media='(max-width: 668px)' />
      )}
      {imageMobile && <source srcSet={imageMobile} media='(max-width: 668px)' />}
      <source type='image/webp' srcSet={imageWebp?.srcSet} sizes={sizes} />
      <img
        className='one-whole height-full'
        ref={imgRef}
        width={imageWebp?.width}
        height={imageWebp?.height}
        alt={imageAlt}
        {...otherProps}
      />
    </picture>
  ) : (
    <img src={image} alt={imageAlt} {...otherProps} />
  );
};
